import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useLenis } from "./lib/useLenis";
import { Navbar } from "./components/sections/Navbar";
import { Hero } from "./components/sections/Hero";
import { EcosystemPitch } from "./components/sections/EcosystemPitch";
import { OTTPlatform } from "./components/sections/OTTPlatform";
import { ProgramBreakdown } from "./components/sections/ProgramBreakdown";
import { PricingHook } from "./components/sections/PricingHook";
import { ComparisonTable } from "./components/sections/ComparisonTable";
import { Manifesto } from "./components/sections/Manifesto";
import { Philosophy } from "./components/sections/Philosophy";
import { VisionMission } from "./components/sections/VisionMission";
import { GymCompat } from "./components/sections/GymCompat";
import { EditorialMarquee } from "./components/sections/EditorialMarquee";
import { Founder } from "./components/sections/Founder";
import { FinalCTA } from "./components/sections/FinalCTA";
import { Footer } from "./components/sections/Footer";

const Home = () => {
  useLenis();
  return (
    <div className="App bg-[#020617]">
      <div className="grain-overlay" />
      <Navbar />
      <main>
        <Hero />
        <EcosystemPitch />
        <OTTPlatform />
        <ProgramBreakdown />
        <PricingHook />
        <ComparisonTable />
        <EditorialMarquee />
        <Manifesto />
        <Philosophy />
        <VisionMission />
        <GymCompat />
        <Founder />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
